import React, {forwardRef} from "react";

/**
 * SUBCOMPONENT: Primary overlay toggle component for VST Company Switcher
 * @class CompanySwitcherToggle
 */
const CompanySwitcherToggle = forwardRef((props, ref) => (
    <a ref={ref}
       href="#toggleVstCompanySwitcherModal"
       data-bl-id="vstUserCompanyOverlayToggleButton"
       className="vst-user__company-select__toggle-button"
       onClick={ (e) => {
           e && e.preventDefault();
           props.onClick(e);
       } }>&nbsp;</a>
));

export default CompanySwitcherToggle;